document.querySelectorAll('.rack-warranty').forEach((page) => {
  const dialog = page.querySelector('[data-rack-warranty-dialog]');
  const type = page.querySelector('[data-rack-warranty-type]');
  if (!dialog || !type) return;

  page.querySelectorAll('[data-rack-warranty-open]').forEach((button) => {
    button.addEventListener('click', () => {
      type.value = button.dataset.inquiry || 'General inquiry';
      dialog.showModal();
    });
  });

  page.querySelector('[data-rack-warranty-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  if (page.querySelector('[data-rack-warranty-success], .rack-warranty__error')) dialog.showModal();
});
